import { createSlice } from '@reduxjs/toolkit';

import eventBus, { EventType } from '@utils/eventBus';

import {
  handleAdminDeleteGlobalMessage,
  handleAdminSetGlobalMessage,
  handleGetAdminGlobalMessage,
} from './actions';
import { IAdminGlobalMessagesState } from './slice.interface';

const initialState: IAdminGlobalMessagesState = {
  data: null,
  isLoading: false,
  error: false,
  isDeleting: false,
};

export const adminGlobalMessagesSlice = createSlice({
  name: 'admin-global-messages',
  initialState,
  reducers: {
    removeAdminGlobalMessages: state => {
      state.data = null;
      state.isLoading = false;
      state.error = false;
      state.isDeleting = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleGetAdminGlobalMessage.pending, (state: IAdminGlobalMessagesState) => {
        state.data = null;
        state.isLoading = true;
        state.error = false;
        state.isDeleting = false;
      })
      .addCase(handleGetAdminGlobalMessage.rejected, (state: IAdminGlobalMessagesState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(
        handleGetAdminGlobalMessage.fulfilled,
        (state: IAdminGlobalMessagesState, action) => {
          const isSet = action.payload.data && action.payload.data.message !== null;
          state.data = isSet ? action.payload.data : null;
          state.isLoading = false;
        },
      )
      .addCase(
        handleAdminSetGlobalMessage.fulfilled,
        (state: IAdminGlobalMessagesState, action) => {
          state.data = action.meta.arg;
          eventBus.emit(EventType.ADMIN_SET_GLOBAL_MESSAGE_SUCCESS);
        },
      )
      .addCase(handleAdminDeleteGlobalMessage.pending, (state: IAdminGlobalMessagesState) => {
        state.isDeleting = true;
      })
      .addCase(handleAdminDeleteGlobalMessage.rejected, (state: IAdminGlobalMessagesState) => {
        state.isDeleting = false;
      })
      .addCase(handleAdminDeleteGlobalMessage.fulfilled, (state: IAdminGlobalMessagesState) => {
        state.isDeleting = false;
        state.data = null;
        eventBus.emit(EventType.ADMIN_DELETE_GLOBAL_MESSAGE_SUCCESS);
      });
  },
});

export const { removeAdminGlobalMessages } = adminGlobalMessagesSlice.actions;

export default adminGlobalMessagesSlice.reducer;
